<template lang="pug">
.upload-multiple-file
  el-row(v-if="text !== ''")
    el-col(
      :span="4"
      :class="{required: isRequired}"
    ) {{ $t(text) }}
    el-col(:span="20")
      template(v-if="fileName && !canEdit")
        a.file-name(
          v-if="files.length === 0"
          :href="downloadUrl"
          :class="{ omit: omitFileName }"
          :title="fileName"
          target="_blank"
        ) {{ fileName }}
        el-tooltip(
          v-else
          effect="light",
          placement="right"
        )
          a(
            :href="downloadUrl"
            :class="{ omit: omitFileName }"
            :title="fileName"
            target="_blank"
          ) {{ fileName }}
          div(slot="content")
            p(
              v-for="file,index of files",
              :key="index",
              style="margin-right: 20px;",
            ) {{ file }}
      .upload-multiple-file__edit(v-else)
        el-upload(
          ref="uploadEdited"
          :disabled="disabled"
          action="组件必传项，无意义"
          :multiple="true"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="upload()",
        )
          el-button(
            :disabled="disabled"
            type="primary",
          ) {{ $t('点击上传') }}
        el-tooltip(
          v-if="editFilePath && fileList.length !== 0"
          effect="light",
          placement="right",
        )
          a(
            :href="editFilePath"
            style="margin-left: 10px"
            :class="{ omit: omitFileName }"
            :title="editFileName"
            target="_blank"
          ) {{ editFileName }}
          div(slot="content")
            p(
              v-for="file,index of fileList",
              :key="index",
              style="margin-right: 20px;",
            ) {{ file }}
        a(
          v-if="editFilePath && fileList.length === 0"
          :href="editFilePath"
          style="margin-left: 10px"
          :class="{ omit: omitFileName }"
          :title="editFileName"
          target="_blank"
        ) {{ editFileName }}
        span(
          v-if="!editFilePath"
          :class="{ omit: omitFileName }"
        )
  template(v-else)
    template(v-if="fileName && !canEdit")
      a.file-name(
        v-if="files.length === 0"
        :href="downloadUrl"
        :class="{ omit: omitFileName }"
        :title="fileName"
        target="_blank"
      ) {{ fileName }}
      el-tooltip(
        v-else
        effect="light",
        placement="right"
      )
        a(
          :href="downloadUrl"
          :class="{ omit: omitFileName }"
          :title="fileName"
          target="_blank"
        ) {{ fileName }}
        div(slot="content")
          p(
            v-for="file,index of files",
            :key="index",
            style="margin-right: 20px;",
          ) {{ file }}
    .upload-multiple-file__edit(v-else)
      el-upload(
        ref="upload"
        :disabled="disabled"
        action="组件必传项，无意义"
        :multiple="true"
        :auto-upload="false"
        :show-file-list="false"
        :on-change="upload()",
      )
        el-button(
          :disabled="disabled"
          type="primary",
        ) {{ $t('点击上传') }}
      el-tooltip(
        v-if="editFilePath && fileList.length !== 0"
        effect="light",
        placement="right",
      )
        a(
          :href="editFilePath"
          style="margin-left: 10px"
          :class="{ omit: omitFileName }"
          :title="editFileName"
          target="_blank"
        ) {{ editFileName }}
        div(slot="content")
          p(
            v-for="file,index of fileList",
            :key="index",
            style="margin-right: 20px;",
          ) {{ file }}
      a(
        v-if="editFilePath && fileList.length === 0"
        :href="editFilePath"
        style="margin-left: 10px"
        :class="{ omit: omitFileName }"
        :title="editFileName"
        target="_blank"
      ) {{ editFileName }}
      span(
        v-if="!editFilePath"
        :class="{ omit: omitFileName }"
      )
</template>

<script>
import axios from 'axios'
import { debounce } from 'lodash'

export default {
  props: {
    isRequired: {
      type: Boolean,
      default () {
        return true
      }
    },
    axiosUrl: {
      type: String,
      isRequired: true,
      default () {
        return ''
      }
    },
    params: {
      type: Object,
      isRequired: false,
      default () {
        return {}
      }
    },
    text: {
      type: String,
      isRequired: true,
      default () {
        return ''
      }
    },
    fileName: {
      type: String,
      isRequired: false,
      default () {
        return null
      }
    },
    downloadUrl: {
      type: String,
      isRequired: false,
      default () {
        return null
      }
    },
    files: {
      type: Array,
      isRequired: false,
      default () {
        return null
      }
    },
    canEdit: {
      type: Boolean,
      isRequired: false,
      default () {
        return false
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    omitFileName: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editFileName: '',
      editFilePath: null,
      fileList: []
    }
  },
  watch: {
    downloadUrl () {
      if (this.canEdit && this.downloadUrl != null) {
        this.editFilePath = this.downloadUrl
        this.editFileName = this.fileName
        this.fileList = this.files
      }
    }
  },
  methods: {
    upload () {
      return debounce((file, files) => {
        const formData = new window.FormData()
        files.forEach((f, i) => {
          formData.append('file' + i, f.raw)
        })
        if (Object.keys(this.params).length !== 0) {
          for (var key in this.params) {
            formData.append(key, this.params[key])
          }
        }
        this.$emit('uploading')
        axios
          .post(this.axiosUrl, formData)
          .then((res) => {
            this.$refs.upload && this.$refs.upload.clearFiles()
            this.$refs.uploadEdited && this.$refs.uploadEdited.clearFiles()
            this.$emit('success', res)
            this.editFileName = res.file_name
            this.editFilePath = res.file_download_path
            this.fileList = res.file_name_list
            this.$message.success(this.$t('提交成功'))
          })
      }, 100)
    }
  }
}
</script>

<style lang="stylus" scoped>
.upload-multiple-file__edit
  display flex
  align-items center
  > span
    margin-left 10px
  .canClick
    cursor pointer
    color #00a0e5

.upload-multiple-file__edit__choose
  margin-right 10px

.file-name
  display inline-block
  width 200px
  white-space nowrap
  text-overflow ellipsis
  overflow hidden

.omit
  display: inline-block
  width: 85px
  text-overflow: ellipsis
  overflow: hidden
  white-space: nowrap
  margin-left: 10px
</style>
